<template>
<div id="invoices">
    <vue-headful title="Invoices" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <!-- hotels FILTERS -->
        <v-row no-gutters>
            <!-- Merchant filter-->
            <v-col cols="12" sm="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Merchant</div>
                    <im-organization-search class="im-select ma-0" placeholder="Any" @input="filterMerchant($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ Merchant filter-->

            <!-- Customer filter-->
            <v-col cols="12" sm="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Customer</div>
                    <im-organization-search class="im-select ma-0" placeholder="Any" @input="filterCustomer($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ Customer filter-->

            <!-- issue date data filter-->
            <v-col cols="12" sm="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Issued</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly placeholder="After ..." v-model="comp_issue_date_from" @input="getItems()" return-object hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="issue_date_from" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text dark color="red" @click="issue_date_from = null; getItems()">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-1">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly placeholder="Before ..." v-model="comp_issue_date_to" @input="getItems()" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="issue_date_to" :min="issue_date_from" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text dark color="red" @click="issue_date_to = null; getItems()">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-card>
            </v-col>
            <!--./ issue date data filter-->

        </v-row>
        <!-- ./ hotels FILTERS -->

        <!-- SEARCH -->
        <div class="im-search py-1">
            <div class="d-flex">
                <v-text-field class="ma-0 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true" medium>swap_vert</v-icon>
            </div>

            <div class="mx-1 py-2 fields d-flex align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn class="mx-1" v-for="field in search_fields" :key="field.value" small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat>
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>


        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;">

            <!-- <v-data-iterator :items="items" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi"> -->
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template slot="item" slot-scope="props">
                    <im-invoice-item :item="props.item" @click.native="seeInvoice(props.item)" />
                </template>

                <template slot="no-data">
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>

            </v-data-iterator>

        </v-card>
        <!--./ DATATABLE ROWS -->

    </v-container>

    <!-- dialog reservation -->
    <v-dialog v-model="dialog_invoice" width="920" max-height="600" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card class="modal-invoice pb-2">
            <v-card flat tile>
                <v-card-title class="headline">
                    Invoice Details
                    <v-spacer />
                    <v-btn icon left @click="dialog_invoice=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
            </v-card>

            <im-invoice-modal v-if="dialog_invoice" :item="invoice" />

            <v-card-actions v-if="$vuetify.breakpoint.smAndUp">
                <v-spacer></v-spacer>
                <v-btn class="mx-1" color="primary" outlined @click="openInvoice(invoice.id)">
                    See Invoice
                </v-btn>
                <v-btn class="mx-1" color="primary" outlined @click="openInvoiceAndAnnexPDF(invoice.id)">
                    Download
                </v-btn>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="mx-1" color="primary" outlined>Send</v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="sendInvoice(invoice.id, 'customer')">
                            <v-list-item-title>Customer</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="sendInvoice(invoice.id, 'merchant')">
                            <v-list-item-title>Merchant</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn class="mx-1" color="primary" outlined @click="confirmChangeStatus(invoice)">
                    Change Status
                </v-btn>
            </v-card-actions>
            <v-speed-dial v-else v-model="fab" bottom right transition="slide-y-reverse-transition">
                <template v-slot:activator>
                    <v-btn v-model="fab" color="primary" dark fab>
                        <v-icon v-if="fab">more_vert</v-icon>
                        <v-icon v-else>close</v-icon>
                    </v-btn>
                </template>
                <v-btn dark small color="blue" @click="openInvoice(invoice.id)">
                    <span>See</span>
                    <v-icon class="pl-1" size="14">visibility</v-icon>
                </v-btn>
                <v-btn dark small color="indigo" @click="openInvoiceAndAnnexPDF(invoice.id)">
                    <span>Download</span>
                    <v-icon class="pl-1" size="14">get_app</v-icon>
                </v-btn>
                <v-btn dark small color="indigo" @click="dialog_send_mail = true">
                    <span>Send</span>
                    <v-icon class="pl-1" size="14">mail_outline</v-icon>
                </v-btn>
                <v-btn dark small :color="invoice.paid ? 'green' : 'red'" @click="confirmChangeStatus(invoice)">
                    <span>Status</span>
                    <v-icon class="pl-1" size="14">attach_money</v-icon>
                </v-btn>
            </v-speed-dial>

        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation -->

    <!-- dialog reservation status -->
    <v-dialog v-model="dialog_payment_status" max-width="400px">
        <v-card>
            <v-card-text class="pt-3 important">
                The invoice {{ invoice.number }} is <span v-if="invoice.paid" class="green--text">Paid</span><span v-else class="red--text">Not paid</span>
            </v-card-text>
            <v-card-text class="regular">
                Are you sure you want to switch the payment status of invoice?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_payment_status = false">
                    No
                </v-btn>
                <v-btn text color="primary" @click="changeStatus">
                    Yes
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation status -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

    <!-- dialog send mail -->
    <v-dialog v-model="dialog_send_mail" max-width="300px">
        <v-card>
            <v-card-text class="important">
                You want to send mail to:
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="sendInvoice(invoice.id, 'customer')">
                    Customer
                </v-btn>
                <v-btn text @click="sendInvoice(invoice.id, 'merchant')">
                    Merchant
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_send_mail = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog send mail -->
</div>
</template>

<script>
import IMOrganizationSearch from "../components/utils/OrganizationSearch.vue";
import IMTableHeader from "../components/utils/IMTableHeader.vue";
import IMSortField from "../components/utils/IMSortField.vue";
import IMInvoiceItem from "../components/items/InvoiceCard.vue";
import IMReservationModal from "../components/items/InvoiceModal.vue";

export default {
    name: `invoices`,

    components: {
        "im-organization-search": IMOrganizationSearch,
        "im-table-header": IMTableHeader,
        "im-sort-filed": IMSortField,
        "im-invoice-item": IMInvoiceItem,
        "im-invoice-modal": IMReservationModal
    },

    data() {
        return {
            fab: false,
            merchant: null,
            customer: null,

            // app state
            dialog_invoice: false,
            invoice: {},

            // date filters
            issue_date_from: null,
            issue_date_to: null,
            filter_merchant_id: null,
            filter_customer_id: null,

            //sort order
            sort_field_item: null,
            sort_field_dir: null,

            // search
            search: null,
            search_timeout: 300,
            search_fields: [
                {
                    text: "Number",
                    value: "invoice_number",
                    selected: true
                }, {
                    text: "Merchant Name",
                    value: "merchant_name",
                    selected: true
                }, {
                    text: "Merchant Code",
                    value: "merchant_fiscal_code",
                    selected: true
                }, {
                    text: "Customer Name",
                    value: "customer_name",
                    selected: true
                }, {
                    text: "Customer Code",
                    value: "customer_fiscal_code",
                    selected: true
                }
            ],
            // table items
            items: [],
            // imemento table
            im_header: [
                {
                    text: "Merchant",
                    width: "25%",
                    sortable: false
                }, {
                    text: "Customer",
                    width: "25%",
                    sortable: false
                }, {
                    text: "Invoice no / Issue date",
                    width: "25%",
                    sortable: true,
                    align: "center",
                    sort_dir: 'desc',
                    sort_order: "issued_at"
                }, {
                    text: "Value",
                    width: "25%",
                    sortable: true,
                    sort_dir: null,
                    align: "right",
                    sort_order: "total"
                }
            ],
            // table attributes
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            // 	dialogs
            dialog_payment_status: false,
            dialog_mobile_sort: false,
            dialog_send_mail: false,
        };
    },

    computed: {
        comp_issue_date_from: {
            get: function () {
                return this.formatDate(this.issue_date_from);
            },
            set: function (val) {
                return (this.issue_date_from = val);
            }
        },
        comp_issue_date_to: {
            get: function () {
                return this.formatDate(this.issue_date_to);
            },
            set: function (val) {
                return (this.issue_date_to = val);
            }
        },
        rppt() {
            return this.$translate.text("app_rppt");
        }
    },

    watch: {
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200);
            }
        }
    },

    created() {
        this.getItems()
    },

    methods: {
        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                orders = ['issued_at'];
                dirs = ['desc'];
            }

            // prepare merchant filter
            let merchant_ids = null;
            if(this.filter_merchant_id) {
                merchant_ids = this.filter_merchant_id;
            }
            // prepare customer filter
            let customer_ids = null;
            if(this.filter_customer_id) {
                customer_ids = this.filter_customer_id;
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/invoices/invoices";
            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    merchant_id: merchant_ids,
                    customer_id: customer_ids,
                    issue_date_from: this.issue_date_from,
                    issue_date_to: this.issue_date_to,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        openInvoice(invoice_id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_INVOICES + "/api/invoices/" + invoice_id + "/html";
            window.open(endpoint, "_blank");
        },

        sendInvoice(invoice_id, destination) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_INVOICES + "/api/invoices/" + invoice_id + "/resend";

            let payload = null;
            if(destination === "customer") {
                payload = {
                    customer: 1
                };
            }
            if(destination === "merchant") {
                payload = {
                    merchant: 1
                };
            }

            this.$axios.get(endpoint, payload)
                .then(response => {
                    this.$emit("success", "Email sent.");
                })
                .catch(error => {
                    console.log(error);
                    this.$emit("error", "Oops, something went wrong");
                });
        },

        openInvoiceAndAnnexPDF(invoice_id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_INVOICES + "/api/invoices/" + invoice_id + "/pdf?annex=1";
            window.open(endpoint, "_blank");
        },

        confirmChangeStatus(current_invoice) {
            this.invoice = current_invoice;
            this.dialog_payment_status = true;
        },

        changeStatus() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/invoices/invoices/" + this.invoice.id;

            if(this.invoice.paid === false) {
                this.$axios.put(endpoint + "/pay")
                    .then(response => {
                        this.invoice.paid = true;
                        this.getItems();
                        this.$emit("success", "Status changed.");
                        this.dialog_payment_status = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$emit("error", "Oops, something went wrong");
                    })
                    .finally(() => {});
            }

            if(this.invoice.paid === true) {
                this.$axios.put(endpoint + "/unpay")
                    .then(response => {
                        this.invoice.paid = false;
                        this.getItems();
                        this.$emit("success", "Status changed.");
                        this.dialog_payment_status = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$emit("error", "Oops, something went wrong");
                    })
                    .finally(() => {});
            }
        },

        seeInvoice(current_invoice) {
            this.invoice = {};
            this.dialog_invoice = true;
            this.invoice = current_invoice;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        filterMerchant(merchant) {
            this.filter_merchant_id = null;
            if(merchant) {
                this.filter_merchant_id = merchant.id;
            }
            this.getItems();
        },

        filterCustomer(customer) {
            this.filter_customer_id = null;
            if(customer) {
                this.filter_customer_id = customer.id;
            }
            this.getItems();
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("D MMM YY");
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        }
    }
};
</script>
<style>
.modal-invoice .v-speed-dial {
    position: absolute;
}

.modal-invoice .v-btn--floating {
    position: relative;
}

@media (max-width: 600px) {
    .v-dialog--fullscreen>.v-card.modal-invoice {
        padding-bottom: 50px !important;
    }

}
</style>
